<template>
	<ul>
		<li class="dialog-list" v-for="item in ordersList" :key="item.orderId">
			<div class="type">
				<span style="font-weight: 600;font-size: 18px;color: #323232;">{{ item.shippingType }}</span>
				<span class="type-style" v-if="item.status == '未支付'">{{ item.status }}</span>
				<span class="type-style2" v-if="item.status == '已支付'">{{ item.status }}</span>
			</div>
			<div class="phone">
				<span class="label">充值账号：</span>
				<span>{{ item.userPhone }}</span>
			</div>
			<div class="time">
				<span class="label">充值时间：</span>
				<span>{{ item.time }}</span>
			</div>
			<div class="tip">
				<span class="label">充值金额：</span>
				<span style="color: red;font-weight: 500;">￥{{ item.orderAmount }}</span>
			</div>
		</li>
	</ul>
</template>

<script>
const isWechat = () => {
	return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger';
};
import { queryXmOrders } from '../api/index.js';
export default {
	data() {
		return {
			ordersList: [],
			openId: '',
			code: ''
		};
	},

	created() {
		this.getWechatCode();
	},

	methods: {
		getWechatCode() {
			if (isWechat) {
				let appid = 'wx68b0128d62be2a7a'; //微信APPid
				this.code = this.getUrlCode().code; //是否存在code
				let local = 'http://topup.10000.work/orderList';
				if (this.code == null || this.code === '') {
					window.location.href =
						'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
						appid +
						'&redirect_uri=' +
						encodeURIComponent(local) +
						'&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect';
				} else {
					this.getQueryXmOrders();
				}
			}
		},
		getUrlCode() {
			// 截取url中的code方法
			var url = location.search;
			var theRequest = new Object();
			if (url.indexOf('?') != -1) {
				var str = url.substr(1);
				var strs = str.split('&');
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
				}
			}
			return theRequest;
		},
		getQueryXmOrders() {
			let data = {
				code: this.code,
				openId: ''
			};
			console.log('我是列表', data);
			queryXmOrders(data).then(res => {
				this.openId = res.message;
				this.ordersList = res.data;
			});
		}
	}
};
</script>

<style scoped>
.dialog-list {
	border-top: 10px solid #f4f4f4;
	width: 100%;
}
.dialog-list .type {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin: 10px 10px 0 10px;
}
.type-style {
	padding: 4px 8px;
	background-color: #f56c6c;
	color: #f1f1f1;
	display: flex;
	height: 20px;
	line-height: 20px;
	border-radius: 10px;
	font-size: 12px;
}
.type-style2 {
	padding: 4px 8px;
	background-color: #67c23a;
	display: flex;
	height: 20px;
	border-radius: 10px;
	line-height: 20px;
	color: #f1f1f1;
	font-size: 12px;
}
.dialog-list .phone {
	display: flex;
	flex-direction: row;
	margin: 10px 10px 0 10px;
}
.label {
	color: #898989;
}
.dialog-list .time {
	display: flex;
	flex-direction: row;
	margin: 10px 10px 0 10px;
}
.dialog-list .tip {
	display: flex;
	flex-direction: row;

	margin: 10px;
}
</style>
